import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext } from '../../../../../AppContext';
import {
  CONFIG_TOY_TABS,
  MODULES,
  PERMISSIONS_KEY,
  PERMISSION_TYPE,
  ROUTES,
} from '../../../../../common/constants';
import { hasPermission } from '../../../../../common/utils';
import Portal from '../../../../../components/Portal';
import ConfigToyTable from '../components/ConfigToyTable';
import ConfigRankingTable from '../components/ConfigRankingTable';
import ConfigReservationRuleTable from '../components/ConfigReservationRuleTable';
import ConfigToyTabs from '../components/ConfigToyTabs';

const TAB_ROUTES = {
  [CONFIG_TOY_TABS?.AVAILABILITY?.key]: `${ROUTES?.CONFIGS}${ROUTES?.DYNAMIC_CONFIGS}${ROUTES?.CONFIG_TOY_AVAILABILITY}`,
  [CONFIG_TOY_TABS?.RANKING?.key]: `${ROUTES?.CONFIGS}${ROUTES?.DYNAMIC_CONFIGS}${ROUTES?.CONFIG_TOY_RANKING}`,
  [CONFIG_TOY_TABS?.RESERVATION_RULES?.key]: `${ROUTES?.CONFIGS}${ROUTES?.DYNAMIC_CONFIGS}${ROUTES?.CONFIG_TOY_RESERVATION_RULES}`,
};

const ConfigToy = ({ initialTab }) => {
  const history = useHistory();
  const {
    state: { permissions },
  } = useContext(AppContext);

  const [activeTabKey, setActiveTabKey] = useState(
    initialTab || CONFIG_TOY_TABS?.AVAILABILITY?.key,
  );

  useEffect(() => {
    setActiveTabKey(initialTab || CONFIG_TOY_TABS?.AVAILABILITY?.key);
  }, [initialTab]);

  const handleTabChange = (key) => {
    setActiveTabKey(key);
    if (TAB_ROUTES[key]) {
      history.push(TAB_ROUTES[key]);
    }
  };

  const [isRuleModalOpen, setIsRuleModalOpen] = useState(false);
  const [currentRule, setCurrentRule] = useState(null);

  const isReservationRulesTab =
    activeTabKey === CONFIG_TOY_TABS?.RESERVATION_RULES?.key;

  const canCreateRule = hasPermission(
    PERMISSIONS_KEY?.CONFIGS,
    PERMISSION_TYPE?.CREATE,
    permissions,
  );

  const showAddRuleButton = isReservationRulesTab && canCreateRule;

  const addRuleButton = (
    <Button
      className="common-button"
      size="middle"
      icon={<PlusOutlined />}
      onClick={() => {
        setCurrentRule(null);
        setIsRuleModalOpen(true);
      }}
    >
      Add Rule
    </Button>
  );

  const renderActiveTabContent = () => {
    if (activeTabKey === CONFIG_TOY_TABS?.RANKING?.key) {
      return <ConfigRankingTable configSubtype={activeTabKey} />;
    }
    if (isReservationRulesTab) {
      return (
        <ConfigReservationRuleTable
          isRuleModalOpen={isRuleModalOpen}
          setIsRuleModalOpen={setIsRuleModalOpen}
          currentRule={currentRule}
          setCurrentRule={setCurrentRule}
        />
      );
    }
    return <ConfigToyTable configSubtype={activeTabKey} />;
  };

  return (
    <>
      <Portal portalId="header-title-content">
        <div className="portal-header">{MODULES?.DYNAMIC_CONFIG_TOY}</div>
      </Portal>

      <Portal portalId="header-right-content">
        {showAddRuleButton && addRuleButton}
      </Portal>

      <Portal portalId="header-right-content-phones">
        {showAddRuleButton && addRuleButton}
      </Portal>

      <ConfigToyTabs activeKey={activeTabKey} onChange={handleTabChange}>
        <div className="tab-table">
          {renderActiveTabContent()}
        </div>
      </ConfigToyTabs>
    </>
  );
};

export default ConfigToy;